import { Check, X } from "lucide-react";
import { useTranslation } from "react-i18next";

/*
 * C2 — Uber-style consignment tracker:
 * Submitted -> Under review -> Accepted | Declined
 */
const STEPS = ["submitted", "under_review", "decision"];

export const SubmissionTracker = ({ status }) => {
  const { t } = useTranslation();
  const idx = status === "submitted" ? 0 : status === "under_review" ? 1 : 2;
  const declined = status === "declined";

  const stepLabel = (step) => {
    if (step !== "decision") return t(`submit.step_${step}`);
    if (status === "accepted") return t("submit.step_accepted");
    if (status === "declined") return t("submit.step_declined");
    return t("submit.step_decision");
  };

  return (
    <div className="flex items-center w-full" data-testid="submission-tracker" aria-label={stepLabel(STEPS[Math.min(idx, 2)])}>
      {STEPS.map((step, i) => {
        const reached = i <= idx;
        const isDecision = step === "decision";
        const dotColor = !reached
          ? "bg-white border-black/15 text-transparent"
          : isDecision && declined
            ? "bg-[#0A0A0A]/70 border-[#0A0A0A]/70 text-white"
            : "bg-[#1D4D3B] border-[#1D4D3B] text-white";
        return (
          <div key={step} className={`flex items-center ${i < STEPS.length - 1 ? "flex-1" : ""}`}>
            <div className="flex flex-col items-center gap-1.5">
              <span className={`w-6 h-6 rounded-full border flex items-center justify-center transition-colors duration-300 ${dotColor}`}>
                {reached && (isDecision && declined ? <X className="w-3.5 h-3.5" aria-hidden="true" /> : <Check className="w-3.5 h-3.5" aria-hidden="true" />)}
              </span>
              <span className={`text-[10px] font-medium whitespace-nowrap ${reached ? "text-[#0A0A0A]" : "text-[#0A0A0A]/35"}`}>
                {stepLabel(step)}
              </span>
            </div>
            {i < STEPS.length - 1 && (
              <div className={`flex-1 h-px mx-2 mb-5 transition-colors duration-300 ${i < idx ? "bg-[#1D4D3B]" : "bg-black/10"}`} />
            )}
          </div>
        );
      })}
    </div>
  );
};
